import { render, staticRenderFns } from "./Main2024.vue?vue&type=template&id=5514c50a"
import script from "./Main2024.vue?vue&type=script&lang=js"
export * from "./Main2024.vue?vue&type=script&lang=js"
import style0 from "./Main2024.vue?vue&type=style&index=0&id=5514c50a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports